import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ImportCRMContactsPayload {
  apiKey: string;
  emailCc?: string;
}

export interface ImportCRMContactsResponse extends Response {
  data: {
    success: boolean;
    importId: string;
    status: string;
    message: string;
    subscriptionId: string;
  };
}

async function importCRMContacts(
  payload: ImportCRMContactsPayload,
  auth: Authentication
): Promise<ImportCRMContactsResponse> {
  try {
    return await HttpClient.post('/integrations/contacts/import', payload, auth.token, false, {
      'x-api-key': payload.apiKey,
    });
  } catch (e: any) {
    console.log('error: ', e);

    const errorMessage = e.message || 'Unknown error';
    throw new ImportCRMContactsFailure(errorMessage, 'import-error');
  }
}

class ImportCRMContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default importCRMContacts;